import React, { Component } from 'react'
import { Table } from 'react-bootstrap';

import SimpleStorageContract from '../../build/contracts/LPCoin.json'
import getWeb3 from '../utils/getWeb3'

const mudata = [0,0,0,0,0,0,0,0,0,0,0,0,0,0];

const contract = require('truffle-contract')
const simpleStorage = contract(SimpleStorageContract)

class MyWife extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      web3: null,
      address: this.props.match.params.address,
      history: []
    };
  }
  
  componentDidMount() {
    getWeb3.then(results => {
      this.setState({ web3: results.web3 })
      this.initHistory()
    }).catch(() => {
      console.log('Error finding web3.')
    })
  }

  initHistory() {
    simpleStorage.setProvider(this.state.web3.currentProvider)
    var simpleStorageInstance;

    this.state.web3.eth.getAccounts((error, accounts) => {
      if (error) {
        console.log(error);
      }
      var account = accounts[0];
      if (this.state.address != "self") {
        account = this.state.address;
      } else {
        this.setState({ address: account });
      }
      simpleStorage.deployed().then((instance) => {
        simpleStorageInstance = instance
        return simpleStorageInstance.showUserHistory(account)
      }).then((result) => {
        // console.log(result)
        this.getHistory(result)
      })
    })
  }

  getHistory(result) {
    var row = result.split(";");
    // console.log(row)
    var i;
    var list = []
    for (i in row) {
      if (row[i].split(",").length > 1) {
        var info = row[i].split(",")
        list[i] = [];
        list[i]["time"] = new Date(parseInt(info[0])).toLocaleString();
        list[i]["name"] = info[1];
        list[i]["lpb"] = info[2];
        list[i]["commit"] = info[3];
      }
    }
    // console.log(list)
    this.setState({ history: list });
  }


  render() {
    return (
      <div className="WifeDetail">
        <main className="container">
				
			<h3>用户: {this.state.address}</h3>

      <div className="col-md-12">
				<br />
				<Table striped condensed hover>
					<thead>
						<tr>
						<th><h3>角色名</h3></th>
            <th><h3>时间</h3></th>
						<th><h3>投币数</h3></th>
            <th><h3>留言</h3></th>
						</tr>
					</thead>
					<tbody>
						{this.state.history.map(function(result, reactid) {
							return (
								<tr key={'tr'+reactid}>
								<td><br />{result.name}<br /><br /></td>
								<td><br />{result.time}<br /><br /></td>
                <td><br />{result.lpb} LPB<br /><br /></td>
                <td><br />{result.commit}<br /><br /></td>
								</tr>
							)
						}.bind(this))}
					</tbody>
				</Table>
			</div>

        </main>
      </div>
    );
  }

}

export default MyWife



// WEBPACK FOOTER //
// ./src/views/MyWife.js